/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Source location and timestamp of IRR Gateway Cert installation.
 */
export interface IrrGwCertInstalledData { 
    gwCertLocation: string;
    installedTimestamp: Date;
}

